/**
 * 확인 창을 브라우저 기본 confirm 대신 화면 안 모달($bvModal.msgBoxConfirm)로 띄우는 공용 조각.
 *
 * 기본 confirm 은 탭 JS 를 멈춰 고객 에이전트(바깥 브라우저 제어 · CDP)가 못 누르고 시간 초과된다
 * (PR261021-D62547 · PR261021-5E05C7). DetailImageEdit 와 같은 꼴 — 화면마다 같은 몸을 복사하지 않고 여기 한 곳에 둔다.
 *
 * 쓰는 법
 *   import confirmInPageMixin from '@/mixins/confirmInPageMixin';
 *   mixins: [confirmInPageMixin]
 *   if (!(await this.confirmInPage('삭제하시겠습니까?'))) return;
 */
export default {
  methods: {
    confirmInPage(message) {
      return this.$bvModal.msgBoxConfirm(message, {
        title: '확인',
        okTitle: '확인',
        cancelTitle: '취소',
        autoFocusButton: 'ok',
        centered: true
      });
    },
  },
};
